module.exports = __webpack_public_path__ + "static/media/17.7c65b910.png";